/* -disable react/style-prop-object */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedNumber } from 'react-intl';
import moment from 'moment';

import ProgressBar from '../../../../../../components/ProgressBar';
import AlertMessage from '../../../../../../components/AlertMessage';
import { getComparative } from '../../../../../../redux/dashboard-completed';
import {
  getDashboardCompletedComparative,
  getDashboardCompletedComparativeUI,
  getDashboardCompletedPeriodListUI,
} from '../../../../../../redux/selectors';

import './styles.css';

class DashboardCompletedDetails extends Component {
  componentDidUpdate(prevProps) {
    const { currentRangeId, data, periodListUI, ui } = this.props;

    if (
      moment(ui.requested).isBefore(periodListUI.received) ||
      (!data && currentRangeId !== prevProps.currentRangeId)
    ) {
      this._getComparative();
    }
  }

  _getComparative = () => {
    this.props.dispatch(getComparative());
  };

  render() {
    const { data, ui } = this.props;

    if (ui.isFetching && !ui.error) {
      return null;
    }

    if (ui.error && !ui.isFetching) {
      return (
        <div className="DashboardCompletedDetails">
          <AlertMessage
            className="DashboardCompletedDetails__error"
            error
            message={ui.error}
            actionText="Tentar novamente"
            onRetry={this._getComparative}
          />
        </div>
      );
    }

    if (!data || !data.nfQuantitySub) {
      return null;
    }

    if (!this.props.isLoading) {
      return (
        <div className="DashboardCompletedDetails">
          <div className="DashboardCompletedDetails__indicators">
            <div className="DashboardCompletedDetails__indicators-nf-counter">
              <div className="DashboardCompletedDetails__indicators-nf-counter-value">
                <FormattedNumber
                  value={data.nfConcentrate}
                  maximumFractionDigits={2}
                />
                %
              </div>
              <div className="DashboardCompletedDetails__indicators-nf-counter-title">
                Concentração de notas
              </div>
            </div>
            <div className="DashboardCompletedDetails__indicators-performance">
              <div className="DashboardCompletedDetails__indicators-performance-value">
                <FormattedNumber
                  value={data.performance}
                  maximumFractionDigits={2}
                />
                %
              </div>
              <ProgressBar completed={data.performance} />
              <div className="DashboardCompletedDetails__indicators-performance-title">
                Performance
              </div>
            </div>
          </div>
          <div className="DashboardCompletedDetails__details-table">
            <div className="DashboardCompletedDetails__details-row-group">
              <div className="DashboardCompletedDetails__details-row">
                <div className="DashboardCompletedDetails__details-row-label">
                  <strong>Valor transportado</strong>
                </div>
                <div className="DashboardCompletedDetails__details-row-value">
                  <strong>
                    <FormattedNumber
                      value={data.transportedValue}
                      style="currency"
                      currency="BRL"
                    />
                  </strong>
                </div>
              </div>
              <div className="DashboardCompletedDetails__details-row">
                <div className="DashboardCompletedDetails__details-row-label">
                  Média por NF
                </div>
                <div className="DashboardCompletedDetails__details-row-value">
                  <FormattedNumber
                    value={data.averageTransportedValue}
                    style="currency"
                    currency="BRL"
                  />
                </div>
              </div>
              <div className="DashboardCompletedDetails__details-row">
                <div className="DashboardCompletedDetails__details-row-label">
                  Média por CTE
                </div>
                <div className="DashboardCompletedDetails__details-row-value">
                  <FormattedNumber
                    value={data.averageCteValue}
                    style="currency"
                    currency="BRL"
                  />
                </div>
              </div>
              <div className="DashboardCompletedDetails__details-row">
                <div className="DashboardCompletedDetails__details-row-label">
                  Concentração
                </div>
                <div className="DashboardCompletedDetails__details-row-value">
                  <FormattedNumber
                    value={data.concentrationValuePercent}
                    style="percent"
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                  />
                </div>
              </div>
            </div>
            <div className="DashboardCompletedDetails__details-row-group DashboardCompletedDetails__details-row-period">
              <div className="DashboardCompletedDetails__details-row">
                <div className="DashboardCompletedDetails__details-row-label">
                  <strong>Peso transportado</strong>
                </div>
                <div className="DashboardCompletedDetails__details-row-value">
                  <strong>
                    <FormattedNumber
                      value={data.nfWeightSub}
                      minimumFractionDigits={2}
                      maximumFractionDigits={2}
                    />{' '}
                    kg
                  </strong>
                </div>
              </div>
              <div className="DashboardCompletedDetails__details-row">
                <div className="DashboardCompletedDetails__details-row-label">
                  Média por NF
                </div>
                <div className="DashboardCompletedDetails__details-row-value">
                  <FormattedNumber
                    value={data.averageTransportedWeight}
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                  />{' '}
                  kg
                </div>
              </div>
              <div className="DashboardCompletedDetails__details-row">
                <div className="DashboardCompletedDetails__details-row-label">
                  Média por CTE
                </div>
                <div className="DashboardCompletedDetails__details-row-value">
                  <FormattedNumber
                    value={data.averageCteWeight}
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                  />{' '}
                  kg
                </div>
              </div>
              <div className="DashboardCompletedDetails__details-row">
                <div className="DashboardCompletedDetails__details-row-label">
                  Concentração
                </div>
                <div className="DashboardCompletedDetails__details-row-value">
                  <FormattedNumber
                    value={data.concentrationTransportedPercent}
                    style="percent"
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
}

// redux

const mapStateToProps = state => ({
  currentRangeId: state.dashboardCompleted.details.currentRangeId,
  data: getDashboardCompletedComparative(state),
  ui: getDashboardCompletedComparativeUI(state),
  periodListUI: getDashboardCompletedPeriodListUI(state),
});

export default connect(mapStateToProps)(DashboardCompletedDetails);
